import React, { useMemo } from "react";
import { useEffect } from "react";
import { useApp } from "../../../contexts";
import { useState } from "react";
import { 
  itemsSearch, 
  itemsBreed, 
  getDexWallet,
  itemsRank,
  createDexWallet
} from "../../../services/app";
import { useNavigate } from "react-router-dom";

import ItemEarner from "../../../components/Item";
import { RowFilter } from "./RowFilter";
import Filter from "./filter/Filter";
import { ArrowDownIcon } from "../../../components/Icons/ArrowDownIcon";
import {ModalMintNotify} from "../../../components/ModalMintNotify";
import * as Notification from "../../../Notification";

import {
  EARNER_DEFAULT_PARAMS,
  ITEM_TYPES,
  ITEM_LIMIT,
} from "../../../constants";
import { useWindowSize } from "../../../hook/useWindowSize";
import FilterMobile from "./filter/FilterMobile";

export const TabEarner = (props) => {
  const size = useWindowSize();
  const isMobile = size.width <= 1024 ? true : false;
  const { T, setLoading, language, user, convertToLocalCurrency,formatLocalCurrency,
    getCurrency } = useApp();
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [dataTab, setDataTab] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  const [isShowCreateWeb3, setIsShowCreatWeb3] = useState(false);
  const [isShowCreateWeb3Success, setIsShowCreatWeb3Success] = useState(false);
  const [breedOptions, $breedOptions] = useState([]);
  const [rankOptions, $rankOptions] = useState([]);
  const [isBtnLoading, $isBtnLoading] = useState();
  const pageSize = useMemo(() => {
    return size.width >= 1536 ? 30 : (size.width >= 1366 ? 25 : 20)
  }, [size])
  const [filterData, $filterData] = useState({
    ...EARNER_DEFAULT_PARAMS,
    size: pageSize,
    itemTypes: [ITEM_TYPES.ITEM_TYPE_DOG],
  });
  const navigate = useNavigate();
  useEffect(() => {
    itemsBreed(ITEM_TYPES.ITEM_TYPE_DOG).then((res) => {
      const data = res?.data?.data?.nftCollections || [];
      $breedOptions(data);
      const dataRanks = res?.data?.data?.nftRanks || [];
      $rankOptions(dataRanks);
    });
  }, []);

  const [filterDataCache, $filterDataCache] = useState(filterData);

  const convertPrice = (filterData) => {
    const convertPrice = {
      priceFrom: undefined,
      priceTo: undefined,
    }
    if(filterData.priceFrom && parseFloat(filterData.priceFrom) >= 0) {
      convertPrice.priceFrom = convertToLocalCurrency(filterData.priceFrom, getCurrency(), 'USD')
    }
    if(filterData.priceTo && parseFloat(filterData.priceTo) >= 0) {
      convertPrice.priceTo = convertToLocalCurrency(filterData.priceTo, getCurrency(), 'USD')
    }
    return convertPrice;
  }
  const handleMint = async () => {
    try {
      const resultDexWallet = await getDexWallet();
      if(resultDexWallet && resultDexWallet.data && resultDexWallet.data.data && resultDexWallet.data.data.public_address) {
        navigate(
          `/mint-nft`
        );
      }else{
        setIsShowCreatWeb3(true)
      }
    }catch(e){
      setIsShowCreatWeb3(true)
    }
  }
  const hanldeCreateWeb3Address = async () => {
    try {
      if (isBtnLoading) return
      $isBtnLoading(true)
      const createResult = await createDexWallet();
      if (createResult?.data?.error?.status) {
        setIsShowCreatWeb3(false);
        setIsShowCreatWeb3Success(true);
      } else {
        Notification.error(T(createResult?.data?.error?.message));
        setIsShowCreatWeb3(false);
      }
    } catch (e) {
      Notification.error(T("Create web3 wallet unsuccessfully"));
      setIsShowCreatWeb3(false);
    }
    $isBtnLoading(false)
  };
  const loadData = async () => {
    setLoading(true);
    const priceConvert = convertPrice(filterData)
    const result = await itemsSearch({...filterData, ...priceConvert});
    setDataTab(result?.data?.data?.items?.rows || []);
    setTotal(result?.data?.data?.items?.count || 0);
    setLoading(false);
  };
  const loadMore = async () => {
    setLoading(true);
    const priceConvert = convertPrice(filterData)
    const result = await itemsSearch({
      ...filterData,
      ...priceConvert,
      page: page + 1,
    });
    setDataTab((prev) => [...prev, ...result?.data?.data?.items?.rows] || []);
    setTotal(result?.data?.data?.items?.count || 0);
    setPage(page + 1);
    setLoading(false);
  };
  const handleShowFilter = () => {
    setShowFilter(!showFilter);
  };
  const handleFilterData = (val) => {
    $filterData({ ...filterData, ...val });
  };
  const handleCacheFilter = (val) => {
    $filterDataCache(val);
  };
  
  useEffect(() => {
    loadData();
  }, [filterData]);

  useEffect(() => {
    $filterData({
      ...filterData,
      size: pageSize
    })
  }, [pageSize]);

  return (
    <div className="flex flex-col gap-[16px] xls:gap-[20px] xls:mt-[10px]">
      <div className="search-input relative">
        <RowFilter
          handleShowFilter={handleShowFilter}
          showFilter={showFilter}
          filterData={filterData}
          type={"dogmall"}
          setFilterData={handleFilterData}
        />
        {isMobile && (
          <FilterMobile
            setFilterData={(val) => handleFilterData(val)}
            setCacheFilter={(val) => handleCacheFilter(val)}
            filterData={filterData}
            breedOptions={breedOptions}
            rankOptions={rankOptions}
            showing={9}
            type={"dogmall"}
          />
        )}
      </div>
      <div className="flex justify-between items-start gap-[40px]">
        {showFilter && !isMobile && (
          <div className="w-[270px] hidden lg:block">
            <Filter
              setFilterData={(val) => handleFilterData(val)}
              filterData={filterData}
              showing={9}
              breedOptions={breedOptions}
              rankOptions={rankOptions}
              type={"dogmall"}
            />
          </div>
        )}
        <div className={`flex-1 ${!showFilter ? "w-full" : ""}`}>
          <div className="asset-block">
            <div className="flex justify-between items-center">
              <div className="mb-[15px] text-base text-black font-[700]">
                {T("Total item: {count}").replace("{count}", total)}
              </div>
              <button
                type="button"
                className="bg-black leading-[40px] lg:leading-[50px] mb-[15px]  !text-white rounded-[10px] min-w-[135px] lg:min-w-[200px] px-[20px] h-[40px] lg:h-[50px] button-boxshadow"
                onClick={() => handleMint()}
              >
                {T("Mint NFT")}
              </button>
            </div>
            {dataTab?.length > 0 ? (
              <>
                <div
                  className={`grid gap-[15px] grid-cols-1 xs:grid-cols-2 xs:gap-[10px] ${
                    showFilter ? "lg:grid-cols-3 xls:grid-cols-4 2xl:grid-cols-5" : "lg:grid-cols-4 xls:grid-cols-5 2xl:grid-cols-6"
                  } lg:gap-[30px]`}
                >
                  {dataTab.map((item, index) => (
                    <ItemEarner
                      key={index}
                      itemData={item}
                      categoryTypes={breedOptions}
                      rankOptions={rankOptions}
                    />
                  ))}
                </div>
              </>
            ) : (
              <>
                <div className="text-[#818181] text-sm flex-wrap lg:text-base flex justify-center items-center">
                  <div className="w-full flex items-center lg:mt-[80px] mb-[16px] justify-center">
                    <img
                      className="w-[100px] lg:w-[160px]"
                      src={"/assets/images/empty-table.png"}
                      alt=""
                    />
                  </div>
                  <div className="w-full flex justify-center mb-[15px]">
                    {T("You haven't got anything yet.")}
                  </div>
                  <a
                    href={`${user.store_shopify}?lang=${user.language}`}
                    target="_blank"
                    rel="noreferrer"
                    className="bg-black leading-[45px] !text-white rounded-[15px] px-[20px] h-[45px] button-boxshadow"
                  >
                    {T("Go to Mall")}
                  </a>
                </div>
              </>
            )}
          </div>
          {total > page * filterData.size && (
            <>
              <div
                className="flex justify-center items-center mt-[40px] gap-[10px]"
                onClick={() => loadMore()}
              >
                {T("Load more")} <ArrowDownIcon />
              </div>
            </>
          )}
        </div>
      </div>
      {isShowCreateWeb3 && (
        <ModalMintNotify
          onClose={() => setIsShowCreatWeb3(false)}
          onSubmit={() => hanldeCreateWeb3Address()}
          isLoading={isBtnLoading}
          title={T("AI Avatar Web3 Wallet not created!")}
          des={T(
            "You have not created AI Avatar Web3 Wallet to store NFT. Please create a AI Avatar Wallet and try again!"
          )}
          buttonText={T("Create Web3 Wallet")}
        />
      )}
      {isShowCreateWeb3Success && (
        <ModalMintNotify
          onClose={() => setIsShowCreatWeb3Success(false)}
          onSubmit={() => handleMint()}
          title={T("Created Web3 Wallet successfully!")}
          des={T(
            "Your web3 wallet has been created successfully. Now you can withdraw SOT from AMS to AI Avatar Web3 Wallet. You can view web3 wallet in AI Avatar application."
          )}
          buttonText={T("Continue to mint")}
        />
      )}
    </div>
  );
};
